import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const senecInputLabelTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            root: {
                lineHeight: 1.9,
                color: theme.palette.neutralGray100.main,
                disabled: {
                    color: theme.palette.neutralGray70.main,
                },
            },
            shrink: {
                transform: "translate(14px, 9px) scale(0.80)",
                lineHeight: 1.2,
            },
        },
    };
};
